import React, { useMemo } from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { enumToMap } from 'helpers/commonHelpers';
import { FormSelectProps, SelectOption } from '@ui';
import { VirtualAssetInvolvementOptions } from 'enums/onboarding/crm';

// components
import { FormSelect } from '@ui';

export type IProps = FormSelectProps;

const VirtualAssetInvolvementSelect = (props: IProps) => {
  const { t } = useTranslation('onboarding');

  const options = useMemo<SelectOption[]>(
    () =>
      Array.from(enumToMap(VirtualAssetInvolvementOptions)).map((e) => ({
        id: e[1],
        label: t(`intake_form.virtual_asset_involvement_options.${e[0]}`),
      })),
    [t],
  );

  return <FormSelect {...props} options={options} />;
};

export default VirtualAssetInvolvementSelect;
